import {useEffect} from 'react';

const MAX_RETRIES = 5;
const RETRY_DELAY_MS = 300;

// Branch (branch.io) is injected via gtag by BI and renders a banner iframe (#branch-banner-iframe).
// That iframe intercepts tab focus, breaking keyboard navigation for accessibility users.
// This hook detects the iframe after injection and sets tabIndex=-1 to remove it from the tab order.
const useBranchIO = () => {
  useEffect(() => {
    let retries = 0;
    let timeoutId: number | undefined;

    const setIframeTabIndex = () => {
      const el = document.getElementById('branch-banner-iframe');

      if (el) {
        // Exclude the Branch iframe from tab navigation so it doesn't hijack keyboard focus.
        el.tabIndex = -1;
        return;
      }

      if (retries < MAX_RETRIES) {
        retries += 1;
        timeoutId = window.setTimeout(setIframeTabIndex, RETRY_DELAY_MS);
      }
    };

    setIframeTabIndex();

    return () => {
      if (timeoutId !== undefined) {
        window.clearTimeout(timeoutId);
      }
    };
  }, []);
};

export default useBranchIO;
